import { Toast } from 'primereact/toast'
import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import { Link, useNavigate, useParams } from 'react-router-dom'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup";

const AddHomeLayout = () => {

    const { id } = useParams()
    const isEdit = id ? true : false

    const toast = useRef(null)
    const navigate = useNavigate()

    const [collectionsData, setCollectionsData] = useState([])
    const [categoryData, setCategoryData] = useState([])
    const [quizData, setQuizData] = useState([])
    const [testimonials, setTestimonials] = useState([])

    const [homeLayoutData, setHomeLayoutData] = useState([])

    const schema = yup.object({
        sectionHeading: yup.string().required("Heading is required"),
        sectionType: yup.string().required("Select Section Type"),
        sectionId: yup.string().required(`This is Required`),
        maxRecord: yup.number().transform((value, originalValue) => (originalValue === "" || isNaN(originalValue)) ? null : value).nullable().required("Max Record is required"),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, watch, setValue, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const sectionType = watch('sectionType')

    const resetValue = () => {
        reset({
            sectionHeading: '',
            sectionType: '',
            sectionId: '',
            maxRecord: '',
            isActive: '',
        })
    }

    useEffect(() => {
        setValue('sectionId', "")
        if (sectionType === "specialCollection" || sectionType === "collection" ) getCollections();
        if (sectionType === "collection") getCollections();
        if (sectionType === "courses") getCategories();
        if (sectionType === "testimonials") setValue('sectionId', "0");
        if (sectionType === "featuredQuiz") getQuiz();
        if (sectionType === "quiz") setValue('sectionId', "0");
        if (sectionType === "category") setValue('sectionId', "0");
    }, [sectionType]);

    useEffect(() => {
        if (isEdit) getHomeLayouts();
    }, []);

    const getHomeLayouts = () => {
        ApiHelper.get(`${API_ENDPOINTS.HOME_LAYOUT}/${id}`).then((res) => {
            if (res.status === 200) {
                setHomeLayoutData(res.data.data)
                reset({
                    sectionHeading: res.data.data.sectionHeading,
                    sectionType: res.data.data.sectionType,
                    sectionId: res.data.data.sectionId,
                    maxRecord: res.data.data.maxRecord,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }
    
    const getCollections = () => {
        ApiHelper.get(`${API_ENDPOINTS.COLLECTION}?active=true`).then((res) => {
            if (res.status === 200) {
                setCollectionsData(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }
    
    const getCategories = () => {
        ApiHelper.get(`${API_ENDPOINTS.CATEGORY}?active=true`).then((res) => {
            if (res.status === 200) {
                setCategoryData(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }
    
    const getQuiz = () => {
        ApiHelper.get(`${API_ENDPOINTS.QUIZ}?active=true`).then((res) => {
            if (res.status === 200) {
                setQuizData(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }
    
    const getTestimonials = () => {
        ApiHelper.get(`${API_ENDPOINTS.TESTIMONIALS}?active=true`).then((res) => {
            if (res.status === 200) {
                setTestimonials(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }


    const onSubmit = (data) => {
        if (isEdit) {
            update(data)
        } else {
            add(data)
        }
    };

    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.HOME_LAYOUT}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/home-layout')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.HOME_LAYOUT}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/home-layout')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    return (
        <>
            <Toast ref={toast} />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/home-layout')}> Home Layout </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/home-layout" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form id="adminUserForm" onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">Section Heading</label>
                                                    <input type="text" name="sectionHeading" class="form-control" {...register("sectionHeading")} />
                                                    <small className="text-danger">{errors.sectionHeading?.message}</small>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">Max Records</label>
                                                    <input type="number" name="maxRecord" class="form-control" {...register("maxRecord")} />
                                                    <small className="text-danger">{errors.maxRecord?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Section Type</label>
                                                    <select id="mySelect" name="sectionType" class="form-select" {...register("sectionType")} >
                                                        <option value="">Select Section Type</option>
                                                        <option value='collection'>Collections</option>
                                                        <option value='specialCollection'>Special Collections</option>
                                                        <option value='courses'>Courses</option>
                                                        <option value='category'>Category</option>
                                                        <option value='quiz'>Quiz</option>
                                                        <option value='testimonials'>Testimonials</option>
                                                        <option value='featuredQuiz'>featured Quiz</option>
                                                    </select>
                                                    <small className="text-danger"> {errors.sectionType?.message} </small>
                                                </div>

                                                {sectionType === "featuredQuiz" && (
                                                    <div className="col-md-3 mb-3">
                                                        <label className="form-label">Quiz</label>
                                                        <select className="form-select" {...register("sectionId")}>
                                                            <option value="">Select Quiz</option>
                                                            {quizData.map((item) => (
                                                                <option key={item.quizId} selected={homeLayoutData.sectionId === item.quizId ? true : false} value={item.quizId}> {item.quizName} </option>
                                                            ))}
                                                        </select>
                                                        <small className="text-danger">{errors.sectionId?.message}</small>
                                                    </div>
                                                )}

                                                {sectionType === "courses" && (
                                                    <div className="col-md-3 mb-3">
                                                        <label className="form-label">Category</label>
                                                        <select className="form-select" {...register("sectionId")}>
                                                            <option value="">Select Category</option>
                                                            {categoryData.map((item) => (
                                                                <option key={item.categoryId} selected={homeLayoutData.sectionId === Number(item.categoryId) ? true : false} value={item.categoryId}> {item.categoryName} </option>
                                                            ))}
                                                        </select>
                                                        <small className="text-danger">{errors.sectionId?.message}</small>
                                                    </div>
                                                )}

                                                {sectionType === "specialCollection" || sectionType === 'collection' ? (
                                                    <div className="col-md-3 mb-3">
                                                        <label className="form-label">Collections</label>
                                                        <select className="form-select" {...register("sectionId")}>
                                                            <option value="">Select Collections</option>
                                                            {collectionsData.map((item) => (
                                                                <option key={item.collectionId} selected={homeLayoutData.sectionId === item.collectionId ? true : false} value={item.collectionId}> {item.collectionName} </option>
                                                            ))}
                                                        </select>
                                                        <small className="text-danger">{errors.sectionId?.message}</small>
                                                    </div>
                                                ) : ''}

                                                <div class="col-md-3">
                                                    <label class="form-label">Status</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AddHomeLayout
